const route = {
  path: 'user-manage',
  name: '用户管理',
  component: {
    render: e => e('router-view')
  },
  children: [
    {
      path: 'user-list',
      name: '用户列表',
      component: () => import('../views/userManage/userList')
    },
    {
      path: 'user-detail',
      name: '用户详情',
      component: () => import('../views/userManage/userDetail')
    }
  ]
}

export default route



// WEBPACK FOOTER //
// ./src/router/userManageRouter.js